<script lang="ts">
	import DebugModal from '$lib/components/DebugModal/DebugModal.svelte';
	import DirectionToggle from '$lib/components/Direction/DirectionToggle.svelte';
	import { isDevelopment } from '$lib/utils/environmentResolver';
	import CookieConsent from '../CookieConsent.svelte';
	import { setHubStores } from '$lib/stores/hubStores';
	import './hub.css';
	import Addons from '$lib/addons/Addons.svelte';
	import SignIn from '$lib/Signin/index.svelte';
	import { globalCssFromBE } from '$lib/utils/globalCssFromBE';
	import type { LayoutData } from './$types';
	import Pendo from '$lib/pendo/pendo.svelte';
	import PostSettingsModal from '$lib/components/Post/Settings/Settings.svelte';
	import { showLogoutStore } from '$lib/stores/sessionExpire';
	import { browser } from '$app/environment';
	import SessionEndWarningModal from '$lib/components/SessionEndWarningModal/SessionEndWarningModal.svelte';
	import WidgetModal from '../../lib/components/WidgetModal/WidgetModal.svelte';
	import PostComposer from '$textEditor/PostComposer/PostComposer.svelte';
	import { isComposerOpen } from '$textEditor/PostComposer/composerStore';
	import { isWidgetModalOpen } from '$lib/components/WidgetModal/widgetHelpers';
	import { screenWidth } from '$lib/stores/resizeStore';

	export let data: LayoutData;
	const {
		respSessionHubUser,
		respHub,
		respCollaborators,
		respFeaturedPosts,
		collectionsData,
		respWidgets,
		api,
		restApi,
		alidaJwt,
		pod,
	} = data;

	setHubStores({
		hub: respHub.hub,
		api,
		restApi,
		pod,
		widgets: respWidgets?.onlyWidgets,
		featuredPosts: respFeaturedPosts?.featuredPosts,
		pinnedPosts: respWidgets?.pinnedPosts,
		collaborators: respCollaborators?.users,
		collections: collectionsData?.filter((collection) => !collection.archived),
		archivedCollections: collectionsData?.filter((collection) => collection.archived),
		user: respSessionHubUser?.user,
		alidaJwt,
	});
	const theme = globalCssFromBE(respHub.hub.theme);

	if (respSessionHubUser?.expiresIn && browser) showLogoutStore.set(respSessionHubUser?.expiresIn);

	let expirationDuration = '';
	$: {
		if (browser) {
			if ($showLogoutStore == 'showModal1Hour') {
				expirationDuration = '60';
			}
			if ($showLogoutStore == 'showModal5Minutes') {
				expirationDuration = '5';
			}
			if ($showLogoutStore == 'reload') {
				window.location.reload();
			}
		}
	}
</script>

{#if $screenWidth != 0}
	<Pendo user_context={respHub.hub.user_context} email={respSessionHubUser?.user.email} />
	<Addons />
	<div id="hubContainer" style={theme}>
		<SignIn>
			{#if $isWidgetModalOpen}
				<WidgetModal />
			{/if}
			{#if $isComposerOpen === true}
				<PostComposer />
			{/if}
			<PostSettingsModal />
			<slot />
		</SignIn>
	</div>
	<CookieConsent />
	{#if isDevelopment(data.pod)}
		<DirectionToggle />
	{/if}
	<DebugModal />
	{#if expirationDuration}
		<SessionEndWarningModal {expirationDuration} />
	{/if}
{/if}

<svelte:head>
	<title>{respHub?.hub.name}</title>
</svelte:head>

<style>
	#hubContainer {
		min-block-size: 100vh;
	}
</style>
